import { render, staticRenderFns } from "./GatheringReviewDetail.vue?vue&type=template&id=55e11c9e&"
import script from "./GatheringReviewDetail.vue?vue&type=script&lang=js&"
export * from "./GatheringReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./GatheringReviewDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GatheringReviewDetail.vue"
export default component.exports